import { skipEmpty } from "./_helpers";

// creates rule that checks if both rules are satisfied
const apply2 = (rule1, rule2) => (value, form, fieldName) =>
	rule1(value, form, fieldName) || rule2(value, form, fieldName);

export const and2Lazy = skipEmpty(apply2);

const pack = (...args) => [].concat(...args);

const join2 = (rule1, rule2) => (value, form, fieldName) => {
	const res1 = rule1(value, form, fieldName);
	const res2 = rule2(value, form, fieldName);
	return (res1 && res2 && pack(res1, res2)) || (res1 && pack(res1)) || (res2 && pack(res2));
};

export const join2Lazy = skipEmpty(join2);

const some2 = (rule1, rule2) => (value, form, fieldName) => {
	const res1 = rule1(value, form, fieldName);
	return res1 ? rule2(value, form, fieldName) : res1;
};

export const some2lazy = skipEmpty(some2);
